const adminActions = {
  ADMIN_STATE_PROP_SET: 'ADMIN_STATE_PROP_SET'
};
export default adminActions;
